import {WizardFocusSerializer} from '../core/services/wizardNavigationService/wizardFocusSerializer.service';
import {HistoryNodeNavigationEngineFactory} from '../core/services/wizardNavigationService/historyNodeNavigationEngine';
import {WizardNavigationService} from '../core/services/wizardNavigationService/wizardNavigationService';
import {IQuoteWizardStepsService} from './quoteWizardSteps/quoteWizardSteps.provider';
import {IWizardNode} from '../core/services/wizardNavigationService/wizardNode';
import {TreeNodeNavigationEngineFactory} from '../core/services/wizardNavigationService/treeNodeNavigationEngine';

export class QuoteWizardNavigationService extends WizardNavigationService {
    public static $inject = [
        '$rootScope',
        '$state',
        '$log',
        '$q',
        '$injector',
        'treeNodeNavigationEngineFactory',
        'historyNavigationEngineFactory',
        'wizardFocusSerializer',
        'quoteWizardStepsService'
    ];

    constructor($rootScope: ng.IRootScopeService,
                $state: ng.ui.IStateService,
                $log: ng.ILogService,
                $q: ng.IQService,
                $injector: ng.auto.IInjectorService,
                navigationEngineFactory: TreeNodeNavigationEngineFactory,
                historyEngineFactory: HistoryNodeNavigationEngineFactory,
                serializer: WizardFocusSerializer,
                protected quoteWizardStepsService: IQuoteWizardStepsService) {
        super($rootScope, $state, $log, $q, $injector, navigationEngineFactory, historyEngineFactory, serializer);
    }

    protected defineWizardNodes(): IWizardNode[] {
        return this.quoteWizardStepsService.getWizardSteps();
    }

    protected onGoBackFromBeginningOfWizard() {
        const welcomeScreenStateName = 'shellFrame.quoteWizardFrame.wizard.welcomeScreen';
        this.$state.go(welcomeScreenStateName);
    }
}
